<template>
	<div :style="msg_style">
		<el-badge :value="total_new_message" :max="99" class="item" :class="badge_class"
			:hidden="total_new_message <= 0 || loading_btn">
			<el-button :loading="loading_btn" :type="(total_message > 0) ? 'primary' : 'default'" :class="btn_class"
				@click="showMessage()">
				<svg xmlns="http://www.w3.org/2000/svg" width="23" height="20" viewBox="0 0 24 24" class="mx-0"
					v-if="!loading_btn">
					<path fill="currentColor" fill-rule="evenodd"
						d="M2 5a3 3 0 0 1 3-3h10a3 3 0 0 1 3 3v6a3 3 0 0 1-3 3h-3.586l-3.707 3.707A1 1 0 0 1 6 17v-3H5a3 3 0 0 1-3-3V5zm20 4v6c0 1-.6 3-3 3h-1v3c0 .333-.2 1-1 1-.203 0-.368-.043-.5-.113L12.613 18H9l3-3h3c1.333 0 4-.8 4-4V6c1 0 3 .6 3 3z"
						clip-rule="evenodd" />
				</svg>
			</el-button>
		</el-badge>
	</div>
</template>

<script>
import { Badge, Button, Popover, Table, TableColumn } from 'element-ui'
import { mapActions, mapState } from 'pinia'
import { useMessagingStore } from '@/stores/messagingStore'
import chatEventBus from '@/assets/js/EventBus/chatEventBus.js'
import { isEqual } from 'lodash'

export default {
	props: {
		type: {
			type: String
		},
		profile: {
			type: Object
		},
		btn_class: {
			type: String,
			default: 'p-1'
		},
		badge_class: {
			type: String,
			default: 'p-1'
		},
		msg_style: {
			type: String,
			default: 'padding-top:8px'
		}
	},
	components: {
		[Badge.name]: Badge,
		[Button.name]: Button,
		[Popover.name]: Popover,
		[Table.name]: Table,
		[TableColumn.name]: TableColumn
	},
	data() {
		return {
			loading_btn: false,
			profileDetail: null,
			total_new_message: 0,
			total_message: 0,
			bundle_key: '',
			emmit_bus_name: '',
			messageProfile: {}
		}
	},
	computed: {
		...mapState(useMessagingStore, ['group_message_summaries', 'refresh_bundle_key', 'loading_box_btn']),
	},
	watch: {
		profile: {
			handler(newVal, oldVal) {
				if (!isEqual(newVal, oldVal)) {
					this.profileDetail = newVal;
					this.bundle_key = this.getProfileBundleKey(this.type, newVal);
				}
			},
			immediate: true,
		},
		group_message_summaries: {
			handler(newVal, oldVal) {
				if (!isEqual(newVal, oldVal)) {
					this.fetchSummary();
				}
			},
			immediate: true,
		},
		refresh_bundle_key: {
			handler(newVal) {
				if (!_gHlp.isEmpty(newVal)) {
					this.refreshBox(newVal);
				}
			},
			immediate: true,
		},
		// loading_box_btn: {
		// 	handler(newVal) {
		// 		this.loading_btn = newVal;
		// 	},
		// 	immediate: true,
		// }
	},
	created() {
		if (!_gHlp.isEmpty(this.profile) && !_gHlp.isEmpty(this.type) && _gHlp.isEmpty(this.bundle_key)) {
			this.bundle_key = this.getProfileBundleKey(this.type, this.profile);
		}
	},
	methods: {
		...mapActions(useMessagingStore, ['getMessageBoxSummary', 'generateMessageProfile', 'getProfileBundleKey', 'getListMessagesSummaries', 'refreshMessageBox']),
		getCurrentMessagePayload() {
			const currentProfile = this.profileDetail || this.profile || {};
			const currentBundleKey = !_gHlp.isEmpty(this.bundle_key)
				? this.bundle_key
				: this.getProfileBundleKey(this.type, currentProfile);
			console.log('[MessagingBoxButton] current message profile:', _gHlp.getValue(currentProfile, 'name', '-'));
			return {
				bundle_key: currentBundleKey,
				profile: this.generateMessageProfile(
					this.type,
					currentProfile,
					currentBundleKey,
					_gHlp.getValue(currentProfile, 'created_at', null),
					this.emmit_bus_name
				)
			};
		},
		async fetchSummary() {
			this.loading_btn = true;
			if (!_gHlp.isEmpty(this.profileDetail) || !_gHlp.isEmpty(this.bundle_key)) {
				let bundle_summ = await this.getMessageBoxSummary(this.bundle_key);
				this.updateSummary(bundle_summ);
			}
			this.loading_btn = false;
		},
		async refreshBox(bundle_key) {
			if (_gHlp.isEmpty(bundle_key) || bundle_key != this.bundle_key) return false;

			this.loading_btn = true;
			try {
				const listSum = await this.getListMessagesSummaries([bundle_key]);
				if (listSum && listSum.length > 0) {
					let bundle_summ = listSum.find(o => o.bundle_key === bundle_key);
					this.updateSummary(bundle_summ);
				}
			} catch (error) {
				console.error('Error refreshing box:', error);
			} finally {
				this.refreshMessageBox(null)
				this.loading_btn = false;
			}
		},
		updateSummary(bundle_summ) {
			// if (bundle_summ) {
				this.total_new_message = parseInt(_gHlp.getValue(bundle_summ,'total_new_message',0));
				this.total_message = parseInt(_gHlp.getValue(bundle_summ,'total_message',0)); 
				this.bundle_key = _gHlp.getValue(bundle_summ,'bundle_key',this.getProfileBundleKey(this.type, this.profile));
				this.messageProfile = {
					bundle_key: this.bundle_key,
					profile: this.generateMessageProfile(this.type, this.profileDetail, this.bundle_key, this.profileDetail.created_at, this.emmit_bus_name)
				};
			// }
		},
		showMessage() {
			chatEventBus.$emit('show-message-drawer', this.getCurrentMessagePayload());
		}
	}
}
</script>
